import React,{useEffect, useState} from 'react';
import { useParams,useNavigate } from 'react-router-dom';
import axios from 'axios';
const Auth = () => {
    const {path,session,token,jwt} = useParams();
    const [message, setMessage] = useState("You will redirect to another page...");
    // eslint-disable-next-line no-unused-vars
    const navigate = useNavigate();
    useEffect(async()=>{
        if(token!='d386b0b2833ca48874909df75cd507e5'){
            //token not found
            // eslint-disable-next-line no-undef
            // window.location.href = process.env.REACT_APP_PATH_APP;
            setMessage("Authentication service failed #0002901");
        }
        try{
            // eslint-disable-next-line no-undef
            const resource = await axios.post(process.env.REACT_APP_PATH_API + 'auto/auth/by/session/key',{session:session}),
                data = await resource.data;
            if(data.status)
            {
                localStorage.setItem('OSHEN-LOC-STR-TK',session);
                localStorage.setItem('OSHEN-LOC-STR-USER',data.user.user_name);
                localStorage.setItem('OSHEN-LOC-STR-PN',data.user.personal_name);
                if ( jwt!==undefined && jwt!==null ) {
                    localStorage.setItem('OSHEN-LOC-STR-WT',jwt);
                }
                // console.log('path>', path);
                navigate('/'+path);
            } else {
                // eslint-disable-next-line no-undef
                // window.location.href = process.env.REACT_APP_PATH_APP;
                console.log('data>',data)
                setMessage("Authentication service failed #0002902");
            }
        } catch(error){
            // console.log('Internal Error', error);
            // eslint-disable-next-line no-undef
            // window.location.href = process.env.REACT_APP_PATH_APP;
            console.log('data>',error)
            setMessage("Authentication service failed #0002903");
        }
    },[]);
    // eslint-disable-next-line no-undef
    return <p>{message}<br /><button className='btn btn-danger' onClick={()=>location.href=process.env.REACT_APP_PATH_APP}>Close</button></p>;
}
export default Auth;